/**
 * External dependencies.
 */
import { has, isEmpty } from 'lodash';

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks';

/**
 * Internal dependencies.
 */
import { getSpacingStyleProperties } from '../../extensions/custom-styles';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

function styling( props, selector = false ) {
	const { size, customSize, iconimgBorderRadius, blockAdvanceOptions, borderRadius, borderWidth } = props.attributes;
	const { iconPadding } = blockAdvanceOptions;

	let css = '';
	selector = selector ? selector : `.gutenify-section-${ props.clientId } .gutenify-icon-wrapper`;

	let styleNormal = '';
	styleNormal += `${ has( blockAdvanceOptions, 'textColor' ) && ! isEmpty( blockAdvanceOptions.textColor ) ? `color: ${ blockAdvanceOptions.textColor };` : '' }`;
	styleNormal += `${ has( blockAdvanceOptions, 'backgroundColor' ) && ! isEmpty( blockAdvanceOptions.backgroundColor ) ? `background: ${ blockAdvanceOptions.backgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'backgroundGradient' ) && ! isEmpty( blockAdvanceOptions.backgroundGradient ) ) {
		styleNormal += `background: ${ blockAdvanceOptions.backgroundGradient };`;
	}
	styleNormal += `${ has( blockAdvanceOptions, 'borderColor' ) && ! isEmpty( blockAdvanceOptions.borderColor ) ? `border-color: ${ blockAdvanceOptions.borderColor };` : '' }`;
	styleNormal += `${ borderWidth > 0 ? `border-width: ${ borderWidth }px;` : '' }`;
	styleNormal += `${ borderWidth > 0 ? `border-style: solid;` : '' }`;
	styleNormal += `${ ! isEmpty( borderRadius ) ? `border-radius: ${ borderRadius };` : '' }`;
	styleNormal += `${ has( iconPadding, 'desktop' ) ? getSpacingStyleProperties( iconPadding.desktop ) : '' }`;
	if ( styleNormal ) {
		css += `${ selector } { ${ styleNormal } }`;
	}

	let styleHover = '';
	styleHover += `${ has( blockAdvanceOptions, 'hoverTextColor' ) && ! isEmpty( blockAdvanceOptions.hoverTextColor ) ? `color: ${ blockAdvanceOptions.hoverTextColor };` : '' }`;
	styleHover += `${ has( blockAdvanceOptions, 'hoverBackgroundColor' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundColor ) ? `background: ${ blockAdvanceOptions.hoverBackgroundColor };` : '' }`;
	if ( has( blockAdvanceOptions, 'hoverBackgroundGradient' ) && ! isEmpty( blockAdvanceOptions.hoverBackgroundGradient ) ) {
		styleHover += `background: ${ blockAdvanceOptions.hoverBackgroundGradient };`;
	}
	styleHover += `${ has( blockAdvanceOptions, 'hoverBorderColor' ) && ! isEmpty( blockAdvanceOptions.hoverBorderColor ) ? `border-color: ${ blockAdvanceOptions.hoverBorderColor };` : '' }`;

	if ( styleHover ) {
		css += `${ selector }:hover { ${ styleHover } }`;
	}

	if ( size ) {
		css += `${ selector } i {
			font-size: ${ size }px;
		}`;
	}

	if ( customSize ) {
		css += `${ selector } img {
			width: ${ size }px;
			max-width: ${ size }px;
		}`;
	}

	css += `${ selector } .gutenify-image-icon-content img {
		border-radius: ${ iconimgBorderRadius }px;
	}`;

	// if ( iconColor ) {
	// 	css += `${ selector } i {
	// 		color: ${ iconColor };
	// 	}`;
	// }

	return applyFilters( `gutenify--${ hookPrefix }--inline-styles`, css, props );
}
export default styling;
